<template>
  <pre 
    class="text-right" 
    dir="ltr"
  >
    {{ getTitle }}
    <slot />
  </pre>
</template>

<script>
  export default {
    name: "JsonViewer",
    props: {
      title: {
        type: String,
        default: null
      }
    },
    data() {
      return {};
    },
    computed: {
      getTitle() {
        if (this.title == null)
          return '';
        else
          return this.title + ': ';
      }
    }
  }
</script>

<style scoped>
  .text-right {
    text-align: left
  }
</style>